import axios from 'axios'
import { Message } from 'element-ui'

// --- 新增：预渲染状态监听变量 ---
let activeRequests = 0;
let renderTimer = null;

function checkRenderEvent() {
  if (activeRequests === 0) {
    if (renderTimer) clearTimeout(renderTimer);
    // 延迟 500ms 确保数据已经渲染到 DOM 树上
    renderTimer = setTimeout(() => {
      if (activeRequests === 0) {
        document.dispatchEvent(new Event('render-event'));
      }
    }, 500);
  }
}
// -----------------------------

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    // --- 新增：增加活跃请求计数 ---
    activeRequests++;
    if (renderTimer) clearTimeout(renderTimer);
    // ----------------------------
    return config
  },
  error => {
    console.log('Request error:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // --- 新增：减少计数并检测是否渲染完毕 ---
    activeRequests--;
    checkRenderEvent();
    // ------------------------------------
    const res = response.data
    return res
  },
  error => {
    // --- 新增：即使失败也要扣减计数，防止卡死 ---
    activeRequests--;
    checkRenderEvent();
    // ------------------------------------
    console.log('Response error:', error)
    Message({
      message: error.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
